import { FETCH_STORE, RESET_STORE } from "../../constants/action.constants";

const initialState = {
  data: {},
};

const storeViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STORE:
      return { data: action.payload };
    case RESET_STORE:
      return initialState;
    default:
      return state;
  }
};

export default storeViewReducer;
